// OWNER: money module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Pages are lazy-loaded so each feature is its own chunk. Add routes here; don't edit the router.
import type { RouteObject } from 'react-router';

const pages = () => import('./pages');

export const routes: RouteObject[] = [
  { path: 'money/accounts', lazy: async () => ({ Component: (await pages()).AccountsPage }) },
  { path: 'money/accounts/:accountId', lazy: async () => ({ Component: (await pages()).AccountDetailPage }) },
  { path: 'money/transactions', lazy: async () => ({ Component: (await pages()).TransactionsPage }) },
  { path: 'money/import', lazy: async () => ({ Component: (await pages()).ImportPage }) },
];
